import * as actionTypes from '../../types/settings/loading';

export function startLoading(payload) {
  return {
    type: actionTypes.START_LOADING,
    payload
  };
}
export function stopLoading(payload) {
  return {
    type: actionTypes.STOP_LOADING,
    payload
  };
}

export function startProgressBar(payload) {
  return {
    type: actionTypes.START_PROGRESS_BAR,
    payload
  };
}
export function stopProgressBar(payload) {
  return {
    type: actionTypes.STOP_PROGRESS_BAR,
    payload
  };
}
export function addProgressBar(payload) {
  return {
    type: actionTypes.ADD_PROGRESS_BAR,
    payload
  };
}
export function clearProgressBar(payload) {
  return {
    type: actionTypes.CLEAR_PROGRESS_BAR,
    payload
  };
}
